import {Injectable} from "@angular/core";
import {BasePageResponse} from "../../core/BaseResponse";
import {ProductResponse} from "../../model/product/ProductResponse";
import {URLS} from "../../core/URLS";
import {HttpClient} from "@angular/common/http";
import {ProductSearchResponse} from "../../model/product/ProductSearchResponse";
import {SearchHistoryResponse} from "../../model/product/SearchHistoryResponse";

@Injectable()
export class ProductSearchService {

  constructor(private httpClient: HttpClient) {
  }

  searchByCategory(page: number, size: number, categoryId: string) {
    return this.httpClient
      .get<BasePageResponse<Array<ProductSearchResponse>>>(URLS.PRODUCT + "/search", {
        params: {
          page: page,
          size: size,
          categoryId: categoryId,
        }
      })
  }

  search(page: number, size: number, search: string) {
    return this.httpClient
      .get<BasePageResponse<Array<ProductSearchResponse>>>(URLS.PRODUCT + "/search", {
        params: {
          page: page,
          size: size,
          search: search,
        }
      })
  }

  searchHistory(page: number, size: number, search: string) {
    return this.httpClient
      .get<BasePageResponse<Array<SearchHistoryResponse>>>(URLS.PRODUCT + "/search/history", {
        params: {
          page: page,
          size: size,
          search: search,
        }
      })
  }

}
